(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid-hero-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Element References
  const toggleBtnHeader = document.getElementById('toggleBtnHeader');
  const images2 = Array.from(document.querySelectorAll('.grid-hero-2-section .gridImage2'));
  const floatingImages = Array.from(document.querySelectorAll('.grid-hero-2-section .gridAdditional2'));
  const allImages = [...images2, ...floatingImages];
  const lightbox2 = document.getElementById('lightbox2');
  const lightboxImg2 = document.getElementById('lightbox2-img');
  const lightboxClose2 = document.getElementById('lightbox2-close');
  const imageGrid2 = document.getElementById('imageGrid2');

  // Store original positions
  const originalPositions = new Map();
  
  // Wait for layout
  setTimeout(() => {
    allImages.forEach((img) => {
      const rect = img.getBoundingClientRect();
      const containerRect = imageGrid2.getBoundingClientRect();
      
      originalPositions.set(img, {
        left: rect.left - containerRect.left,
        top: rect.top - containerRect.top,
        width: rect.width,
        height: rect.height,
        position: img.style.position || 'relative',
        zIndex: img.style.zIndex || 'auto'
      });
    });
  }, 300);

  let gridMode2 = false;

  // Premium Drag & Drop
  function makeDraggable2(el) {
    let isDragging = false;
    
    function dragStart(e) {
      if (e.target !== el) return;
      isDragging = true;
      e.preventDefault();
      
      const origTransition = el.style.transition;
      el.style.transition = 'none';
      el.style.zIndex = '20'; // Beim Draggen ganz oben
      
      const pt = e.touches ? e.touches[0] : e;
      const startX = pt.clientX;
      const startY = pt.clientY;
      const rect = el.getBoundingClientRect();
      const gridRect = imageGrid2.getBoundingClientRect();
      const offsetX = startX - rect.left;
      const offsetY = startY - rect.top;

      function dragMove(ev) {
        if (!isDragging) return;
        ev.preventDefault();
        const mv = ev.touches ? ev.touches[0] : ev;
        let x = mv.clientX - gridRect.left - offsetX;
        let y = mv.clientY - gridRect.top - offsetY;
        
        x = Math.max(0, Math.min(x, gridRect.width - el.offsetWidth));
        y = Math.max(0, Math.min(y, gridRect.height - el.offsetHeight));
        
          el.style.left = x + 'px';
          el.style.top = y + 'px';
      }

      function dragEnd() {
        isDragging = false;
        el.style.transition = origTransition;
        el.style.zIndex = el.classList.contains('gridAdditional2') ? '10' : '5';
        document.removeEventListener('mousemove', dragMove);
        document.removeEventListener('mouseup', dragEnd);
        document.removeEventListener('touchmove', dragMove);
        document.removeEventListener('touchend', dragEnd);
      }

      document.addEventListener('mousemove', dragMove);
      document.addEventListener('mouseup', dragEnd);
      document.addEventListener('touchmove', dragMove, { passive: false });
      document.addEventListener('touchend', dragEnd);
    }

    el.addEventListener('mousedown', dragStart);
    el.addEventListener('touchstart', dragStart, { passive: false });
  }

  // Premium Random Positions
  function generateRandomPositions2() {
    const gridRect = imageGrid2.getBoundingClientRect();
    const positions = [];
    const padding = 50;
    
    allImages.forEach(img => {
      const maxX = Math.max(padding, gridRect.width - img.offsetWidth - padding);
      const maxY = Math.max(padding, gridRect.height - img.offsetHeight - padding);
      positions.push({
        x: padding + Math.random() * (maxX - padding),
        y: padding + Math.random() * (maxY - padding),
        rotation: (Math.random() - 0.5) * 10 // Leichte Rotation
      });
    });
    
    return positions;
  }

  // Enter Drag Mode - Premium Animation
  function enterDragMode2() {
    const randomPositions = generateRandomPositions2();
    
    images2.forEach((img, index) => {
      makeDraggable2(img);
      img.classList.add('dragMode2');
      img.style.cursor = 'move';
      img.style.position = 'absolute';
      img.style.gridArea = 'unset';
      
      // Bilder animieren (sind bereits sichtbar)
      setTimeout(() => {
        img.style.left = randomPositions[index].x + 'px';
        img.style.top = randomPositions[index].y + 'px';
        img.style.transform = `scale(1.1) rotate(${randomPositions[index].rotation}deg)`;
      }, index * 30); // Schnellere Staggering
    });
    
    gridMode2 = true;
  }

  // Exit Drag Mode - Premium Return Animation
  function exitDragMode2() {
    images2.forEach((img, i) => {
      img.classList.remove('dragMode2');
      img.style.cursor = 'pointer';
      img.style.transform = 'scale(1) rotate(0deg)';
      
      // Bilder zurück ins Grid bringen aber sichtbar lassen
      setTimeout(() => {
        img.style.opacity = '1'; // Sichtbar bleiben!
        const pos = originalPositions.get(img);
        if (pos) {
          img.style.position = 'relative'; // Zurück zum Grid-Layout
          img.style.left = '';
          img.style.top = '';
          img.style.width = '';
          img.style.height = '';
          img.style.gridArea = ''; // Grid-Position wiederherstellen
        }
      }, i * 50); // Schnelles, elegantes Timing
    });
    
    gridMode2 = false;
    
    // Lightbox reaktivieren
    setTimeout(() => {
      initLightbox2();
    }, images2.length * 50 + 500);
  }

  // Toggle Button
  if (toggleBtnHeader) {
    toggleBtnHeader.addEventListener('click', () => {
      gridMode2 ? exitDragMode2() : enterDragMode2();
    });
  }

  // Lightbox Functions
  function openLightbox2(src) {
    if (gridMode2) return;
    lightboxImg2.src = src;
    lightbox2.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox2() {
    lightbox2.classList.remove('active');
    document.body.style.overflow = 'auto';
  }

  function initLightbox2() {
    images2.forEach(img => {
      img.addEventListener('click', function(e) {
        if (!gridMode2 && !e.defaultPrevented) {
          openLightbox2(this.src);
        }
      });
    });

    // Floating images auch klickbar
    floatingImages.forEach(img => {
      img.addEventListener('click', function(e) {
        if (!gridMode2) {
          openLightbox2(this.src);
        }
      });
    });
  }

  // Lightbox Close Events
  lightboxClose2?.addEventListener('click', closeLightbox2);
  lightbox2?.addEventListener('click', function(e) {
    if (e.target === lightbox2) closeLightbox2();
    });

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeLightbox2();
  });

  // Initialize
  initLightbox2();

  // Grid startet standardmäßig im normalen Grid-Layout (sichtbar)
  // Drag-Modus kann über Toggle-Button aktiviert werden
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-hero"] && !Shopify.designMode) return;
  try {
    
// Start preloading images immediately (before DOM is ready)
(function() {
  // Wait a tiny bit for DOM to start parsing, then start preloading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPreloading);
  } else {
    startPreloading();
  }
  
  function startPreloading() {
    // Preload grid images
    const gridImages = document.querySelectorAll('.grid-hero-section .gridImage, .grid-hero-section .gridAdditional');
    const sliderImages = document.querySelectorAll('.grid-hero-section .slider-image');
    const allImages = [...gridImages, ...sliderImages];
    const imageUrls = new Set();
    
    // Collect all image URLs
    allImages.forEach(img => {
      if (img.src || img.getAttribute('src')) {
        const src = img.src || img.getAttribute('src');
        if (src) imageUrls.add(src);
      }
    });
    
    // Preload all images
    imageUrls.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      link.fetchPriority = 'high';
      document.head.appendChild(link);
      
      // Force load
      const img = new Image();
      img.src = url;
    });
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  // ---- Element References ----
  const toggleBtn = document.getElementById('toggleBtn');
  const toggleBtnHeader = document.getElementById('toggleBtnHeader');
  const images = Array.from(document.querySelectorAll('.grid-hero-section .gridImage, .grid-hero-section .gridAdditional'));
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxClose = document.getElementById('lightbox-close');
  const gridContainer = document.getElementById('gridContainer');
  const gridSection = document.querySelector('.grid-hero-section');
  const topContentArea = document.getElementById('topContentArea');
  const toggleBtnContainer = document.querySelector('.grid-hero-section .toggle');

  // Determine which toggle button to use (header for homepage, floating for others)
  const activeToggleBtn = toggleBtnHeader || toggleBtn;

  // Store original positions for grid mode
  const originalPositions = [];
  
  // Wait for images to load, then store positions
  setTimeout(() => {
    images.forEach(img => {
      originalPositions.push({
        left: img.offsetLeft,
        top: img.offsetTop
      });
    });
  }, 100);

  let gridMode = false; // false = grid, true = drag mode



  // ---- Drag & Drop Functionality ----
  function makeDraggable(el) {
    function dragStart(e) {
      e.preventDefault();
      const origTransition = el.style.transition;
      el.style.transition = 'none';
      
      const pt = e.touches ? e.touches[0] : e;
      const startX = pt.clientX;
      const startY = pt.clientY;
      const rect = el.getBoundingClientRect();
      const gridRect = document.getElementById('imageGrid').getBoundingClientRect();
      const offsetX = startX - rect.left;
      const offsetY = startY - rect.top;

      function dragMove(ev) {
        ev.preventDefault();
        const mv = ev.touches ? ev.touches[0] : ev;
        let x = mv.clientX - gridRect.left - offsetX;
        let y = mv.clientY - gridRect.top - offsetY;
        
        // Boundary checking for grid images
        if (!el.classList.contains('gridAdditional')) {
          x = Math.max(0, Math.min(x, gridRect.width - el.offsetWidth));
          y = Math.max(0, Math.min(y, gridRect.height - el.offsetHeight));
        }
        
        window.requestAnimationFrame(() => {
          el.style.left = x + 'px';
          el.style.top = y + 'px';
        });
      }

      function dragEnd() {
        el.style.transition = origTransition;
        document.removeEventListener('mousemove', dragMove);
        document.removeEventListener('mouseup', dragEnd);
        document.removeEventListener('touchmove', dragMove);
        document.removeEventListener('touchend', dragEnd);
      }

      document.addEventListener('mousemove', dragMove);
      document.addEventListener('mouseup', dragEnd);
      document.addEventListener('touchmove', dragMove, { passive: false });
      document.addEventListener('touchend', dragEnd);
    }

    el.removeEventListener('mousedown', el._dragStart);
    el.removeEventListener('touchstart', el._touchStart);
    el._dragStart = dragStart;
    el._touchStart = dragStart;
    el.addEventListener('mousedown', dragStart);
    el.addEventListener('touchstart', dragStart, { passive: false });
  }

  function removeDraggable(el) {
    if (el._dragStart) el.removeEventListener('mousedown', el._dragStart);
    if (el._touchStart) el.removeEventListener('touchstart', el._touchStart);
  }

  // ---- Premium Random Positions ----
  function generateRandomPositions() {
    const gridRect = document.getElementById('imageGrid').getBoundingClientRect();
    const positions = [];
    const padding = 50;
    
    images.forEach(img => {
      const maxX = Math.max(padding, gridRect.width - img.offsetWidth - padding);
      const maxY = Math.max(padding, gridRect.height - img.offsetHeight - padding);
      positions.push({
        x: padding + Math.random() * (maxX - padding),
        y: padding + Math.random() * (maxY - padding),
        rotation: (Math.random() - 0.5) * 10 // Leichte Rotation
      });
    });
    
    return positions;
  }

  // ---- Enter Drag Mode - Premium Animation ----
  function enterDragMode() {
    const randomPositions = generateRandomPositions();
    
    images.forEach((img, index) => {
      makeDraggable(img);
      img.classList.add('dragMode');
      img.style.cursor = 'move';
      
      // Schnelle, elegante Animation mit angepasster Skalierung für floating Elemente
      setTimeout(() => {
        img.style.left = randomPositions[index].x + 'px';
        img.style.top = randomPositions[index].y + 'px';
        
        // Unterschiedliche Skalierung für Grid-Bilder vs Floating Elemente
        if (img.classList.contains('gridAdditional')) {
          // Floating Elemente: CSS-Skalierung beibehalten, nur Rotation hinzufügen
          const isMobile = window.innerWidth <= 600;
          const scale = isMobile ? 0.2 : 0.3;
          img.style.transform = `scale(${scale}) rotate(${randomPositions[index].rotation}deg)`;
        } else {
          // Grid-Bilder: normale Größe
          img.style.transform = `scale(1.1) rotate(${randomPositions[index].rotation}deg)`;
        }
      }, index * 15); // Sehr schnelles Staggering: 15ms statt 30ms
    });
    
    if (activeToggleBtn) {
      activeToggleBtn.src = activeToggleBtn.getAttribute('data-alt-src');
      activeToggleBtn.classList.add('toggled');
    }
    gridMode = true;
  }

  // ---- Exit Drag Mode - Premium Return Animation ----
  function exitDragMode() {
    images.forEach((img, i) => {
      removeDraggable(img);
      img.classList.remove('dragMode');
      img.style.cursor = 'pointer';
      
      // Unterschiedliche Skalierung: Grid-Bilder normal, Floating Elements klein
      if (img.classList.contains('gridAdditional')) {
        // Floating Elemente: CSS-Skalierung beibehalten (immer klein)
        const isMobile = window.innerWidth <= 600;
        const scale = isMobile ? 0.2 : 0.3;
        img.style.transform = `scale(${scale}) rotate(0deg)`;
      } else {
        // Grid-Bilder bekommen normale Größe
        img.style.transform = 'scale(1) rotate(0deg)';
      }
      
      // Elegante Rückkehr mit Ease
      setTimeout(() => {
        if (originalPositions[i]) {
          img.style.left = originalPositions[i].left + 'px';
          img.style.top = originalPositions[i].top + 'px';
        }
      }, i * 50); // Schnelles, elegantes Timing
    });
    
    if (activeToggleBtn) {
      activeToggleBtn.src = activeToggleBtn.getAttribute('data-orig-src');
      activeToggleBtn.classList.remove('toggled');
    }
    gridMode = false;
    
    // Lightbox reaktivieren
    setTimeout(() => {
      initLightbox();
    }, images.length * 50 + 500);
  }

  // ---- Toggle Event Listener ----
  // Disabled: No more drag mode toggle, grid stays in grid mode
  // if (activeToggleBtn) {
  //   activeToggleBtn.addEventListener('click', () => {
  //     gridMode ? exitDragMode() : enterDragMode();
  //   });
  // }



  // ---- Lightbox Functionality ----
  function openLightbox(src) {
    if (gridMode) return; // Only open in grid mode
    
    // Set image source
    lightboxImg.src = src;
    
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = 'auto';
  }

  function initLightbox() {
    const threshold = 10; // Pixel threshold for tap vs drag
    let startX, startY, moved;

    document.querySelectorAll('.grid-hero-section .gridImage, .grid-hero-section .gridAdditional').forEach(img => {
      // Touch tap filter
      img.addEventListener('touchstart', function(e) {
        const t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        moved = false;
      }, { passive: true });

      img.addEventListener('touchmove', function(e) {
        const t = e.touches[0];
        if (Math.abs(t.clientX - startX) > threshold || 
            Math.abs(t.clientY - startY) > threshold) {
          moved = true;
        }
      }, { passive: true });

      // Only open lightbox if not moved (tap, not drag)
      img.addEventListener('touchend', function() {
        if (!moved && !gridMode) {
          openLightbox(this.src);
        }
      });

      // Desktop click
      img.addEventListener('click', () => {
        if (!gridMode) {
          openLightbox(img.src);
        }
      });
    });
  }

  // ---- Lightbox Close Events ----
  if (lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }
  
  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  }

  // Keyboard controls
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeLightbox();
    }
    
    // 'D' key to toggle debug mode (Mobile & Desktop)
    if (e.key === 'd' || e.key === 'D') {
      toggleDebugMode();
    }
  });

  // ---- DEBUG TOOL - Mobile & Desktop ----
  let debugMode = false;

  function toggleDebugMode() {
    debugMode = !debugMode;
    
    if (debugMode) {
      showDebugOverlay();
      showNotification('DEBUG MODE ON - Press D to toggle');
    } else {
      hideDebugOverlay();
      showNotification('DEBUG MODE OFF');
    }
  }

  function showNotification(message) {
    const notification = document.getElementById('debugNotification');
    if (notification) {
      notification.textContent = message;
      notification.classList.add('show');
      setTimeout(() => {
        notification.classList.remove('show');
      }, 2000);
    }
  }

  function showDebugOverlay() {
    const debugOverlay = document.getElementById('debugOverlay');
    const imageGrid = document.getElementById('imageGrid');
    if (!debugOverlay || !imageGrid) return;

    debugOverlay.innerHTML = ''; // Clear existing debug elements
    debugOverlay.classList.add('active');

    // Warte bis Layout berechnet ist
    requestAnimationFrame(() => {
      // Bildnummern hinzufügen
      images.forEach((img, index) => {
        const imageNumber = document.createElement('div');
        imageNumber.className = 'image-number';
        imageNumber.textContent = index + 1;
        imageNumber.style.left = (img.offsetLeft + 5) + 'px';
        imageNumber.style.top = (img.offsetTop + 5) + 'px';
        debugOverlay.appendChild(imageNumber);
      });

      // Alle wichtigen Gaps für Mobile & Desktop
      const allGaps = [
        // Row 1 horizontale Gaps
        { from: 1, to: 2, type: 'horizontal', label: 'H1-2' },
        { from: 2, to: 3, type: 'horizontal', label: 'H2-3' },
        
        // Row 2 horizontale Gaps  
        { from: 4, to: 5, type: 'horizontal', label: 'H4-5' },
        { from: 5, to: 6, type: 'horizontal', label: 'H5-6' },
        
        // Row 3 horizontale Gaps
        { from: 7, to: 8, type: 'horizontal', label: 'H7-8' },
        { from: 8, to: 9, type: 'horizontal', label: 'H8-9' },
        
        // Row 4 horizontale Gaps
        { from: 10, to: 11, type: 'horizontal', label: 'H10-11' },
        { from: 11, to: 12, type: 'horizontal', label: 'H11-12' },
        
        // Row 5 horizontale Gaps
        { from: 13, to: 14, type: 'horizontal', label: 'H13-14' },
        { from: 14, to: 15, type: 'horizontal', label: 'H14-15' },
        
        // Vertikale Gaps zwischen Rows
        { from: 1, to: 4, type: 'vertical', label: 'V1-4' },
        { from: 2, to: 5, type: 'vertical', label: 'V2-5' },
        { from: 3, to: 6, type: 'vertical', label: 'V3-6' },
        { from: 4, to: 7, type: 'vertical', label: 'V4-7' },
        { from: 5, to: 8, type: 'vertical', label: 'V5-8' },
        { from: 6, to: 9, type: 'vertical', label: 'V6-9' },
        { from: 7, to: 10, type: 'vertical', label: 'V7-10' },
        { from: 8, to: 11, type: 'vertical', label: 'V8-11' },
        { from: 9, to: 12, type: 'vertical', label: 'V9-12' },
        { from: 10, to: 13, type: 'vertical', label: 'V10-13' },
        { from: 11, to: 14, type: 'vertical', label: 'V11-14' },
        { from: 12, to: 15, type: 'vertical', label: 'V12-15' }
      ];

      allGaps.forEach(gap => {
        const img1 = images[gap.from - 1];
        const img2 = images[gap.to - 1];
        
        if (!img1 || !img2) return;

        if (gap.type === 'horizontal') {
          // Horizontaler Gap
          const gapSize = Math.abs(img2.offsetLeft - (img1.offsetLeft + img1.offsetWidth));
          const centerY = img1.offsetTop + img1.offsetHeight / 2;
          const gapX = img1.offsetLeft + img1.offsetWidth;
          
          if (gapSize >= 0) {
            const label = document.createElement('div');
            label.className = 'gap-indicator';
            label.textContent = `${gap.label}: ${Math.round(gapSize)}px`;
            label.style.left = (gapX + gapSize / 2 - 20) + 'px';
            label.style.top = (centerY - 8) + 'px';
            debugOverlay.appendChild(label);
          }
        } else {
          // Vertikaler Gap
          const gapSize = Math.abs(img2.offsetTop - (img1.offsetTop + img1.offsetHeight));
          const centerX = img1.offsetLeft + img1.offsetWidth / 2;
          const gapY = img1.offsetTop + img1.offsetHeight;
          
          if (gapSize >= 0) {
            const label = document.createElement('div');
            label.className = 'gap-indicator';
            label.textContent = `${gap.label}: ${Math.round(gapSize)}px`;
            label.style.left = (centerX - 20) + 'px';
            label.style.top = (gapY + gapSize / 2 - 6) + 'px';
            debugOverlay.appendChild(label);
          }
        }
      });
    });
  }

  function hideDebugOverlay() {
    const debugOverlay = document.getElementById('debugOverlay');
    if (debugOverlay) {
      debugOverlay.classList.remove('active');
      debugOverlay.innerHTML = '';
    }
  }

  // Debug-Tool bei Fenster-Resize aktualisieren (nur wenn aktiv)
  window.addEventListener('resize', () => {
    if (debugMode) {
      setTimeout(showDebugOverlay, 200);
    }
  });

  // ---- Initialize Everything ----
  // Initialize lightbox
  initLightbox();


  // ---- Grid Shift Animation after 1.3 seconds ----
  function shiftGridDown() {
    // Find elements fresh in case they weren't loaded initially
    const container = document.getElementById('gridContainer');
    const topArea = document.getElementById('topContentArea');
    
    if (!container) {
      console.error('Grid container not found');
      return;
    }

    // Show top content area first (expands from height 0 to auto)
    if (topArea) {
      topArea.classList.add('visible');
      
      // Check if video mode is enabled
      const isVideoMode = topArea.classList.contains('video-mode');
      
      // Wait for the top area to expand and measure its actual height
      setTimeout(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // For video mode, use 100vh, otherwise measure actual height
              let topAreaHeight;
              if (isVideoMode) {
                topAreaHeight = window.innerHeight; // 100vh
              } else {
                topAreaHeight = topArea.offsetHeight;
              }
              // Larger gap on desktop, smaller on mobile
              const isDesktop = window.innerWidth > 600;
              const gap = isDesktop ? 150 : 80; // 150px gap on desktop, 80px on mobile
              const totalShift = topAreaHeight + gap;

              // Get all grid images
              const gridImages = container.querySelectorAll('.gridImage, .gridAdditional');
              const imageGrid = container.querySelector('#imageGrid');
              
              if (imageGrid && gridImages.length > 0) {
                // Get grid dimensions
                const gridRect = imageGrid.getBoundingClientRect();
                const gridHeight = gridRect.height;
                
                // First, calculate and set CSS variables for each image
                // Each image gets a unique delay based on its index AND position
                gridImages.forEach((img, index) => {
                  const imgRect = img.getBoundingClientRect();
                  const imgTop = imgRect.top - gridRect.top;
                  
                  // Calculate position as percentage (0 = top, 1 = bottom)
                  const positionRatio = Math.max(0, Math.min(1, imgTop / gridHeight));
                  
                  // Each image gets a unique delay: combination of position and index
                  // Index-based delay: 0-400ms spread across all images
                  const indexDelay = (index / gridImages.length) * 400;
                  // Position-based delay: 0-300ms based on vertical position
                  const positionDelay = positionRatio * 300;
                  // Combined unique delay for each image
                  const delay = indexDelay + positionDelay;
                  
                  // Additional offset for lower images to create "drag" effect (0px for top, up to 60px for bottom)
                  // This makes them appear to be "pulled" from behind
                  const dragOffset = positionRatio * 60;
                  
                  // Set CSS custom properties for each image
                  img.style.setProperty('--drag-delay', delay);
                  img.style.setProperty('--drag-offset', dragOffset);
                });
                
                // Force a reflow to ensure CSS variables are applied
                void container.offsetHeight;
                
                // Now add shifting class to activate drag effect CSS
                container.classList.add('shifting');
                
                // Ensure CSS variables are applied before starting animation
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    // Now shift grid container down with speedramp animation
                    // The images will follow with their individual delays
                    container.classList.add('shifted');
                    container.style.transform = `translateY(${totalShift}px)`;
                    
                    // Remove shifting class after animation completes
  setTimeout(() => {
                      container.classList.remove('shifting');
                      gridImages.forEach((img) => {
                        img.style.removeProperty('--drag-delay');
                        img.style.removeProperty('--drag-offset');
                      });
                    }, 3000); // Slightly longer than animation duration (2.4s + max delay ~600ms)
                  });
    });
              } else {
                // Fallback if no images found
                container.classList.add('shifted');
                container.style.transform = `translateY(${totalShift}px)`;
              }
            });
          });
      }, 200); // Small delay to allow top area to expand
    } else {
      // Fallback: if no top area, just shift by 80px
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Still apply drag effect even in fallback
          const gridImages = container.querySelectorAll('.gridImage, .gridAdditional');
          const imageGrid = container.querySelector('#imageGrid');
          
          if (imageGrid && gridImages.length > 0) {
            const gridRect = imageGrid.getBoundingClientRect();
            const gridHeight = gridRect.height;
            
            // First, calculate and set CSS variables for each image
            // Each image gets a unique delay based on its index AND position
            gridImages.forEach((img, index) => {
              const imgRect = img.getBoundingClientRect();
              const imgTop = imgRect.top - gridRect.top;
              const positionRatio = Math.max(0, Math.min(1, imgTop / gridHeight));
              
              // Each image gets a unique delay: combination of position and index
              const indexDelay = (index / gridImages.length) * 400;
              const positionDelay = positionRatio * 300;
              const delay = indexDelay + positionDelay;
              
              const dragOffset = positionRatio * 60;
              
              img.style.setProperty('--drag-delay', delay);
              img.style.setProperty('--drag-offset', dragOffset);
            });
            
            // Force a reflow
            void container.offsetHeight;
            
            // Add shifting class
            container.classList.add('shifting');
            
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                container.classList.add('shifted');
                container.style.transform = 'translateY(80px)';
                
      setTimeout(() => {
                  container.classList.remove('shifting');
                  gridImages.forEach((img) => {
                    img.style.removeProperty('--drag-delay');
                    img.style.removeProperty('--drag-offset');
                  });
                }, 3000); // Slightly longer than animation duration (2.4s + max delay ~600ms)
              });
            });
          } else {
            container.classList.add('shifted');
            container.style.transform = 'translateY(80px)';
          }
        });
      });
    }
  }

  // ---- Grid Hero start (after Index Animation or immediately) ----
  function runGridHeroAnimations() {
    const gridContainer = document.getElementById('gridContainer');
    if (gridContainer) {
      gridContainer.classList.add('blur-in');
    }
    animateGridImages();
    setTimeout(() => {
      shiftGridDown();
    }, 1300);
  }

  var indexAnimationLoadingScreen = document.getElementById('indexAnimationLoadingScreen');
  if (indexAnimationLoadingScreen) {
    // Index Animation section is on the page: wait for its "complete" event
    window.addEventListener('index-animation-complete', function handler() {
      window.removeEventListener('index-animation-complete', handler);
      runGridHeroAnimations();
    });
  } else {
    // No Index Animation section: run grid hero animations immediately and trigger header
    runGridHeroAnimations();
    if (document.body.classList.contains('is-homepage')) {
      setTimeout(function() {
        document.body.classList.add('header-animation-ready');
      }, 2000);
    }
  }

  // ---- Grid Images Blur Animation ----
  function animateGridImages() {
    const gridImages = Array.from(document.querySelectorAll('.grid-hero-section .gridImage, .grid-hero-section .gridAdditional'));
    
    if (gridImages.length === 0) return;
    
    // Shuffle array for random order
    const shuffledImages = [...gridImages];
    for (let i = shuffledImages.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledImages[i], shuffledImages[j]] = [shuffledImages[j], shuffledImages[i]];
    }
    
    // Total window: 0.8s for all images to finish
    const totalWindow = 800; // 0.8 seconds total
    const animationDuration = 600; // 0.6 seconds per animation
    // Calculate delay step so the last image finishes at 0.8s
    // Last image must start at: totalWindow - animationDuration = 800 - 600 = 200ms
    // So delays should be spread over 200ms
    const delayWindow = totalWindow - animationDuration;
    const delayStep = shuffledImages.length > 1 ? delayWindow / (shuffledImages.length - 1) : 0;
    
    // Animate each image with random order but all finish within 0.8s
    shuffledImages.forEach((img, index) => {
      const delay = Math.round(index * delayStep);
      
      setTimeout(() => {
        img.classList.add('animate-in');
      }, delay);
    });
  }
  
  // ---- Image Slider Functionality ----
  function initImageSlider() {
    const slider = document.getElementById('imageSlider');
    const slidesWrapper = document.getElementById('slidesWrapper');
    const prevBtn = document.getElementById('sliderPrev');
    const nextBtn = document.getElementById('sliderNext');
    
    if (!slider || !slidesWrapper) return;
    
    const originalSlides = Array.from(slidesWrapper.querySelectorAll('.slide'));
    if (originalSlides.length <= 1) return; // No need for slider if only one or no slides
    
    // Clone slides for infinite loop
    // Add clones at the end (for continuous right scrolling)
    originalSlides.forEach((slide, index) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('slide-clone');
      slidesWrapper.appendChild(clone);
    });
    
    // Add clones at the beginning (for continuous left scrolling)
    for (let i = originalSlides.length - 1; i >= 0; i--) {
      const clone = originalSlides[i].cloneNode(true);
      clone.classList.add('slide-clone');
      slidesWrapper.insertBefore(clone, originalSlides[0]);
    }
    
    const allSlides = Array.from(slidesWrapper.querySelectorAll('.slide'));
    let currentSlide = originalSlides.length; // Start at first original slide (after clones at beginning)
    let isAnimating = false;
    const totalOriginalSlides = originalSlides.length;
    
    // Update slider position
    function updateSlider(jumpToPosition) {
      const slideWidth = slider.offsetWidth;
      const translateX = -currentSlide * slideWidth;
      
      if (jumpToPosition) {
        // Jump without animation
        slidesWrapper.style.transition = 'none';
        slidesWrapper.style.transform = `translateX(${translateX}px)`;
        // Re-enable transition after jump
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            slidesWrapper.style.transition = '';
          });
        });
        isAnimating = false;
      } else {
        if (isAnimating) return;
        isAnimating = true;
        slidesWrapper.style.transform = `translateX(${translateX}px)`;
        // Reset animation flag after transition and check for jump
        setTimeout(() => {
          isAnimating = false;
          
          // Check if we need to jump to maintain infinite loop
          if (currentSlide >= totalOriginalSlides * 2) {
            // Scrolled past all original slides, jump to first original
            currentSlide = totalOriginalSlides;
            updateSlider(true);
          } else if (currentSlide < totalOriginalSlides) {
            // Scrolled before all original slides, jump to last original
            currentSlide = totalOriginalSlides * 2 - 1;
            updateSlider(true);
          }
        }, 500); // Match CSS transition duration
      }
    }
    
    // Next slide (slide continuously to the right)
    function nextSlide() {
      if (isAnimating) return;
      currentSlide++;
      updateSlider();
    }
    
    // Previous slide (slide continuously to the left)
    function prevSlide() {
      if (isAnimating) return;
      currentSlide--;
      updateSlider();
    }
    
    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }
    
    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;
    
    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide(); // Swipe left = next (slide from right to left)
        } else {
          prevSlide(); // Swipe right = previous (slide from left to right)
        }
      }
    }
    
    // Keyboard navigation
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      }
    });
    
    // Make slider focusable for keyboard navigation
    slider.setAttribute('tabindex', '0');
    
    // Hide arrows if only one slide
    if (totalOriginalSlides <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }
    
    // Initialize - start at first original slide
    updateSlider(true); // Jump without animation to initial position
    
    // Handle window resize
    window.addEventListener('resize', () => {
      updateSlider(true); // Jump without animation on resize
    });
  }
  
  // Initialize slider when DOM is ready
  initImageSlider();

  // ---- Video Slider Functionality ----
  function initVideoSlider() {
    const videoSlider = document.getElementById('videoSlider');
    const videoSlidesWrapper = document.getElementById('videoSlidesWrapper');
    const videoPrevBtn = document.getElementById('videoSliderPrev');
    const videoNextBtn = document.getElementById('videoSliderNext');
    
    if (!videoSlider || !videoSlidesWrapper) return;
    
    const videoSlides = Array.from(videoSlidesWrapper.querySelectorAll('.video-slide'));
    if (videoSlides.length <= 1) {
      // Hide arrows if only one video
      if (videoPrevBtn) videoPrevBtn.style.display = 'none';
      if (videoNextBtn) videoNextBtn.style.display = 'none';
    }
    
    // Clone videos for infinite loop
    videoSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('video-slide-clone');
      videoSlidesWrapper.appendChild(clone);
    });
    
    for (let i = videoSlides.length - 1; i >= 0; i--) {
      const clone = videoSlides[i].cloneNode(true);
      clone.classList.add('video-slide-clone');
      videoSlidesWrapper.insertBefore(clone, videoSlides[0]);
    }
    
    const allVideoSlides = Array.from(videoSlidesWrapper.querySelectorAll('.video-slide'));
    let currentVideoSlide = videoSlides.length; // Start at first original video
    let isVideoAnimating = false;
    const totalOriginalVideos = videoSlides.length;
    
    // Play all videos
    allVideoSlides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video) {
        video.play().catch(e => console.log('Video autoplay prevented:', e));
      }
    });
    
    // Update video slider position
    function updateVideoSlider(jumpToPosition) {
      const slideWidth = videoSlider.offsetWidth;
      const translateX = -currentVideoSlide * slideWidth;
      
      if (jumpToPosition) {
        videoSlidesWrapper.style.transition = 'none';
        videoSlidesWrapper.style.transform = `translateX(${translateX}px)`;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            videoSlidesWrapper.style.transition = '';
          });
        });
        isVideoAnimating = false;
      } else {
        if (isVideoAnimating) return;
        isVideoAnimating = true;
        videoSlidesWrapper.style.transform = `translateX(${translateX}px)`;
        setTimeout(() => {
          isVideoAnimating = false;
          
          // Infinite loop handling
          if (currentVideoSlide >= totalOriginalVideos * 2) {
            currentVideoSlide = totalOriginalVideos;
            updateVideoSlider(true);
          } else if (currentVideoSlide < totalOriginalVideos) {
            currentVideoSlide = totalOriginalVideos * 2 - 1;
            updateVideoSlider(true);
          }
        }, 500);
      }
    }
    
    // Next video
    function nextVideo() {
      if (isVideoAnimating) return;
      currentVideoSlide++;
      updateVideoSlider();
    }
    
    // Previous video
    function prevVideo() {
      if (isVideoAnimating) return;
      currentVideoSlide--;
      updateVideoSlider();
    }
    
    // Event listeners for arrows
    if (videoPrevBtn) {
      videoPrevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        prevVideo();
      });
    }
    
    if (videoNextBtn) {
      videoNextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        nextVideo();
      });
    }
    
    // Touch/swipe support
    let videoTouchStartX = 0;
    let videoTouchEndX = 0;
    const videoSwipeThreshold = 50;
    
    videoSlider.addEventListener('touchstart', (e) => {
      videoTouchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    videoSlider.addEventListener('touchend', (e) => {
      videoTouchEndX = e.changedTouches[0].screenX;
      handleVideoSwipe();
    }, { passive: true });
    
    function handleVideoSwipe() {
      const diff = videoTouchStartX - videoTouchEndX;
      if (Math.abs(diff) > videoSwipeThreshold) {
        if (diff > 0) {
          nextVideo();
        } else {
          prevVideo();
        }
      }
    }
    
    // Click on video to navigate to link
    allVideoSlides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        // Don't trigger if clicking on navigation arrows
        if (e.target.closest('.video-slider-arrow')) return;
        
        const videoLink = slide.getAttribute('data-video-link');
        if (videoLink) {
          window.location.href = videoLink;
        }
      });
    });
    
    // Keyboard navigation
    videoSlider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevVideo();
      } else if (e.key === 'ArrowRight') {
        nextVideo();
      }
    });
    
    // Make slider focusable for keyboard navigation
    videoSlider.setAttribute('tabindex', '0');
    
    // Initialize - start at first original video
    updateVideoSlider(true);
    
    // Handle window resize
    window.addEventListener('resize', () => {
      updateVideoSlider(true);
    });
  }
  
  // Initialize video slider when DOM is ready
  initVideoSlider();

  // ---- Countdown Timer Functionality ----
  function initCountdown() {
    const countdownTimer = document.getElementById('countdownTimer');
    const countdownDays = document.getElementById('countdownDays');
    const countdownHours = document.getElementById('countdownHours');
    const countdownMinutes = document.getElementById('countdownMinutes');
    const countdownSeconds = document.getElementById('countdownSeconds');
    
    if (!countdownTimer) return; // No countdown if element doesn't exist
    
    // Get countdown date from data attribute or use default
    const countdownDate = countdownTimer.getAttribute('data-date');
    if (!countdownDate) return;
    
    const targetDate = new Date(countdownDate).getTime();
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;
      
      if (distance < 0) {
        // Countdown finished
        if (countdownDays) countdownDays.textContent = '00';
        if (countdownHours) countdownHours.textContent = '00';
        if (countdownMinutes) countdownMinutes.textContent = '00';
        if (countdownSeconds) countdownSeconds.textContent = '00';
        return;
      }
      
      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Update display
      if (countdownDays) countdownDays.textContent = String(days).padStart(2, '0');
      if (countdownHours) countdownHours.textContent = String(hours).padStart(2, '0');
      if (countdownMinutes) countdownMinutes.textContent = String(minutes).padStart(2, '0');
      if (countdownSeconds) countdownSeconds.textContent = String(seconds).padStart(2, '0');
    }
    
    // Update immediately
    updateCountdown();
    
    // Update every second
    setInterval(updateCountdown, 1000);
  }
  
  // Initialize countdown when DOM is ready
  initCountdown();

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-animation"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const loadingScreen = document.getElementById('indexAnimationLoadingScreen');
    const overlayEl = document.getElementById('indexAnimationOverlay');
    if (!loadingScreen) return;

    const STORAGE_KEY = 'loadingScreenShown';
    const EVENT_NAME = 'index-animation-complete';
    const duration = 1800;
    const pauseAt100 = 300;

    function finishLoading() {
      loadingScreen.classList.add('index-animation--hidden');
      if (document.body.classList.contains('is-homepage')) {
        setTimeout(function() {
          document.body.classList.add('header-animation-ready');
        }, 100);
      }
      window.dispatchEvent(new CustomEvent(EVENT_NAME));
    }

    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      loadingScreen.classList.add('index-animation--hidden');
      loadingScreen.style.display = 'none';
      if (document.body.classList.contains('is-homepage')) {
        document.body.classList.add('header-animation-ready');
      }
      window.dispatchEvent(new CustomEvent(EVENT_NAME));
      return;
    }

    sessionStorage.setItem(STORAGE_KEY, 'true');

    var startTime = Date.now();
    var initialOverlayOpacity = 1;
    if (loadingScreen.dataset.initialOverlayOpacity !== undefined) {
      initialOverlayOpacity = parseFloat(loadingScreen.dataset.initialOverlayOpacity) / 100;
      if (isNaN(initialOverlayOpacity)) initialOverlayOpacity = 1;
    }
    var direction = (loadingScreen.dataset.overlayDirection || '100_to_0');
    var fadeIn = (direction === '0_to_100');
    if (overlayEl && !fadeIn) {
      loadingScreen.style.setProperty('--index-animation-overlay-opacity-animated', String(initialOverlayOpacity));
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function updateAnimation() {
      var elapsed = Date.now() - startTime;
      var progressTime = Math.min(elapsed, duration);
      var t = progressTime / duration;
      var easedProgress = easeInOutCubic(t);
      var overlayOpacity = fadeIn
        ? initialOverlayOpacity * easedProgress
        : initialOverlayOpacity * (1 - easedProgress);
      if (overlayEl) {
        loadingScreen.style.setProperty('--index-animation-overlay-opacity-animated', String(overlayOpacity));
      }

      if (progressTime < duration) {
        requestAnimationFrame(updateAnimation);
      } else {
        if (overlayEl) {
          loadingScreen.style.setProperty('--index-animation-overlay-opacity-animated', fadeIn ? String(initialOverlayOpacity) : '0');
        }
        setTimeout(finishLoading, pauseAt100);
      }
    }

    requestAnimationFrame(updateAnimation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interview-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = document.querySelector('.interview-section').id.replace('interview-', '');
  const startButton = document.getElementById(`startInterview-${sectionId}`);
  const readAgainButton = document.getElementById(`readAgain-${sectionId}`);
  const scrollIndicator = document.getElementById(`scrollIndicator-${sectionId}`);
  const interviewHeader = document.getElementById(`interviewHeader-${sectionId}`);
  const interviewContent = document.getElementById(`interviewContent-${sectionId}`);
  const interviewEnd = document.getElementById(`interviewEnd-${sectionId}`);
  
  const qaPairs = document.querySelectorAll(`#interview-${sectionId} .qa-pair`);
  
  let interviewStarted = false;
  let currentIndex = 0;
  let isTransitioning = false;
  let touchStartY = 0;
  let touchEndY = 0;
  let lastScrollTime = 0;
  let hasReachedEnd = false;
  const isMobile = window.innerWidth <= 750;

  // Reset Interview to initial state
  function resetInterview() {
    interviewStarted = false;
    currentIndex = 0;
    isTransitioning = false;
    hasReachedEnd = false;
    
    // Reset all elements
    interviewHeader.classList.remove('hidden');
    interviewContent.classList.add('hidden');
    scrollIndicator.classList.add('hidden');
    
    // Hide all Q&A pairs and end section
    qaPairs.forEach(pair => {
      pair.classList.remove('active', 'visible');
    });
    interviewEnd.classList.remove('visible');
    
    // Re-enable normal scrolling
    document.body.style.overflow = 'auto';
    
    // Scroll back to the interview header
    interviewHeader.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  // Start Interview Function
  function startInterview() {
    if (interviewStarted) return;
    
    interviewStarted = true;
    
    // Hide header and show content
    interviewHeader.classList.add('hidden');
    interviewContent.classList.remove('hidden');
    scrollIndicator.classList.remove('hidden');
    scrollIndicator.classList.add('active');
    
    // Disable body scroll during interview
    document.body.style.overflow = 'hidden';
    
    // Show first Q&A immediately (index 0)
    setTimeout(() => {
      showQAPair(0);
    }, 100);
  }

  // Show specific Q&A pair
  function showQAPair(index) {
    if (index < 0 || index >= qaPairs.length) return;
    
    // Hide all pairs
    qaPairs.forEach(pair => {
      pair.classList.remove('active', 'visible');
    });
    
    // Show current pair
    if (qaPairs[index]) {
      qaPairs[index].classList.add('active');
      
      // Scroll to center of viewport
      const rect = qaPairs[index].getBoundingClientRect();
      const scrollTop = window.pageYOffset;
      const elementTop = rect.top + scrollTop;
      const windowHeight = window.innerHeight;
      const elementHeight = rect.height;
      const scrollTo = elementTop - (windowHeight / 2) + (elementHeight / 2);
      
      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });
    }
    
    currentIndex = index;
  }

  // Show end section
  function showEndSection() {
    hasReachedEnd = true;
    
    // Hide all Q&A pairs
    qaPairs.forEach(pair => {
      pair.classList.remove('active', 'visible');
    });
    
    interviewEnd.classList.add('visible');
    
    // Scroll to end section - use scrollIntoView for better centering
    setTimeout(() => {
      interviewEnd.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }, 100);
    
    // Hide scroll indicator
    scrollIndicator.classList.add('hidden');
    
    // Re-enable normal scrolling after a delay
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 2000);
  }

  // Next Q&A pair
  function nextQA() {
    if (isTransitioning || hasReachedEnd) return;
    isTransitioning = true;
    
    if (currentIndex < qaPairs.length - 1) {
      currentIndex++;
      showQAPair(currentIndex);
    } else {
      // Show end section
      showEndSection();
    }
    
    setTimeout(() => {
      isTransitioning = false;
    }, 800);
  }

  // Previous Q&A pair
  function previousQA() {
    if (isTransitioning || currentIndex <= 0) return;
    
    // If at end, go back to last question
    if (hasReachedEnd) {
      hasReachedEnd = false;
      interviewEnd.classList.remove('visible');
      document.body.style.overflow = 'hidden';
      scrollIndicator.classList.remove('hidden');
      showQAPair(qaPairs.length - 1);
      return;
    }
    
    isTransitioning = true;
    currentIndex--;
    showQAPair(currentIndex);
    
    setTimeout(() => {
      isTransitioning = false;
    }, 800);
  }

  // Touch handlers for swipe navigation
  function handleTouchStart(e) {
    if (!interviewStarted) return;
    touchStartY = e.changedTouches[0].screenY;
  }

  function handleTouchEnd(e) {
    if (!interviewStarted) return;
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
  }

  function handleSwipe() {
    const swipeDistance = touchStartY - touchEndY;
    const minSwipeDistance = 50;
    
    if (Math.abs(swipeDistance) > minSwipeDistance) {
      if (swipeDistance > 0) {
        // Swipe up - next
        nextQA();
      } else {
        // Swipe down - previous
        previousQA();
      }
    }
  }

  // Improved wheel/scroll event handler
  function handleScroll(e) {
    if (!interviewStarted) return;
    
    // If we've reached the end, allow normal scrolling
    if (hasReachedEnd) return;
    
    e.preventDefault();
    
    const currentTime = Date.now();
    if (currentTime - lastScrollTime < 600) return; // Debounce
    lastScrollTime = currentTime;
    
    if (isTransitioning) return;
    
    const delta = e.deltaY || e.detail || e.wheelDelta;
    
    if (delta > 0) {
      // Scroll down - next
      nextQA();
    } else if (delta < 0) {
      // Scroll up - previous  
      previousQA();
    }
  }

  // Event Listeners
  if (startButton) {
    startButton.addEventListener('click', startInterview);
  }
  
  if (readAgainButton) {
    readAgainButton.addEventListener('click', resetInterview);
  }

  // Touch Events for Mobile Swipe
  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });

  // Scroll/Wheel events
  window.addEventListener('wheel', handleScroll, { passive: false });
  window.addEventListener('DOMMouseScroll', handleScroll, { passive: false }); // Firefox

  // Keyboard Support
  document.addEventListener('keydown', (e) => {
    if (!interviewStarted) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        startInterview();
      }
    } else {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        nextQA();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        previousQA();
      } else if (e.key === 'Escape' && hasReachedEnd) {
        resetInterview();
      }
    }
  });

  // Regular scroll handling (for after interview ends)
  window.addEventListener('scroll', () => {
    if (!interviewStarted || hasReachedEnd) return;
    
    // This handles cases where user scrolls manually during interview
    const scrollTop = window.pageYOffset;
    const windowHeight = window.innerHeight;
    
    // Check which Q&A pair is currently in view
    qaPairs.forEach((pair, index) => {
      const rect = pair.getBoundingClientRect();
      const isInView = rect.top <= windowHeight * 0.5 && rect.bottom >= windowHeight * 0.5;
      
      if (isInView && index !== currentIndex && !isTransitioning) {
        currentIndex = index;
        pair.classList.add('active');
      }
    });
    
    // Check if end section is in view
    const endRect = interviewEnd.getBoundingClientRect();
    if (endRect.top <= windowHeight * 0.5 && !hasReachedEnd) {
      showEndSection();
    }
  }, { passive: true });

  // Intersection Observer for non-mobile fallback
  if (!isMobile) {
    const observerOptions = {
      threshold: [0.3, 0.6],
      rootMargin: '0px 0px -30% 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    qaPairs.forEach(pair => observer.observe(pair));
    observer.observe(interviewEnd);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
